import React from "react";

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
}

// Renders both light and dark logo variants. CSS in App.css hides the
// inactive one based on the [data-theme] attribute on <html>, so the
// switch is instant and avoids any React-side re-render.
const Logo: React.FC<LogoProps> = ({
  width = 100,
  height = 100,
  className = "",
  style,
  alt = "",
}) => {
  const cls = `themedLogo ${className}`.trim();
  return (
    <>
      <img
        src="/assets/imgs/black-logo.svg"
        alt={alt}
        width={width}
        height={height}
        className={`${cls} themedLogo--light`}
        style={style}
      />
      <img
        src="/assets/imgs/white-logo.svg"
        alt={alt}
        width={width}
        height={height}
        className={`${cls} themedLogo--dark`}
        style={style}
      />
    </>
  );
};

export default Logo;
